//Dependencies
import React from 'react'
//Components
import { SolicitudViolenciaSectionContainer } from './GeneralMicroComponents/SolicitudViolenciaSectionContainer'
import { InputGroup } from '../../../ui/InputGroup'
import { DemandFormatSolicitudViolencia } from './DemandFormatSolicitudViolencia'

//Mocks de los inputs de la primera parte del formulario
import { FirstPartInputs } from './inputsDataMock'
import { Grid } from '@mui/material'
import { InputTextAreaComponent } from '../../../ui/InputTextAreaComponent'

//Descripción: Componente que contiene la primera parte de los inputs del formulario de la vista de la pagina Solicitud de Violencia
const FirstFormSectionSolicitudViolencia = () => {
  return (
    <SolicitudViolenciaSectionContainer>
      <p className='field-title__background card-content p-3 mb-4 w-full'>1.- Tus datos</p>
      <div className='w-full m-auto p-3'>  
        <InputGroup itemData={FirstPartInputs[0]} /> 

        <Grid container spacing={2} className='m-auto w-full p-4'>
          {[...FirstPartInputs.slice(1).map((item, index) => (
            <InputGroup itemData={item} key={index} />
          ))]}
        </Grid>

        <InputTextAreaComponent formValue={"demandingDescription"} limit={500} label="Breve Síntesis de la Demanda"/>
      </div>

      <DemandFormatSolicitudViolencia/>
    </SolicitudViolenciaSectionContainer>
  )
}

export {FirstFormSectionSolicitudViolencia}